import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TokenService } from '@core/services/token.service';
import { UserRightsService } from '@core/services/user-rights.service';
import { RouteService } from '@core/services/route.service';
import { AddRouteToHistory, InitHistory } from '@core/store/action/route-history.actions';
import { filter } from 'rxjs';
import { Store } from '@ngxs/store';
import { ToastComponent } from './modules/toasts/toast-component/toast.component';
import { SpinnerComponent } from './modules/spinner/spinner.component';

@UntilDestroy()
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SpinnerComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public title = 'dms-front';

  constructor(
    private readonly tokenService: TokenService,
    private userRightsService: UserRightsService,
    private routeService: RouteService,
    private router: Router,
    private store: Store,
  ) {}

  public ngOnInit(): void {
    this.initSubscriptions();
    this.store.dispatch(new InitHistory());
    this.initRouteSubscriptions();
  }

  private initSubscriptions(): void {
    this.tokenService.isAuthenticated$.pipe(untilDestroyed(this)).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.getUserRights();
      }
    });
  }

  private initRouteSubscriptions(): void {
    this.router.events
      .pipe(
        filter((ev): ev is NavigationEnd => ev instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe((ev) => {
        const url = this.routeService.clean(ev.urlAfterRedirects);
        this.routeService.addRoute(url);
      });
  }

  private getUserRights(): void {
    this.userRightsService
      .getUserRights()
      .pipe(untilDestroyed(this))
      .subscribe(
        () => {},
        () => {},
      );
  }
}
